import { render, staticRenderFns } from "./brandSelect.vue?vue&type=template&id=8afb0a3e&lang=pug"
import script from "./brandSelect.vue?vue&type=script&lang=js"
export * from "./brandSelect.vue?vue&type=script&lang=js"
import style0 from "./brandSelect.vue?vue&type=style&index=0&id=8afb0a3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports